const UserDetailsRoute = {
  path: '/user/details/:id?',
  load: () => import('./UserDetails'),
  protected: true,
};

export { UserDetailsRoute };
